import { Box, IconOptions, Text } from '@jfs/ui-new'
import { useEffect } from 'react';
import { styles } from './styles'
export enum TimeOut {
  NEVER = -1,
  NOW = 1,
  ONE_SECOND = 1000,
  THREE_SECONDS = 3000,
  FIVE_SECONDS = 5000,
  SIX_SECONDS = 6000,
  TEN_SECONDS = 10000,
  FIFTEEN_SECONDS = 15000,
  THIRTY_SECONDS = 30000,
}
const ToastPosition = {
  TOP: 'Top',
  BOTTOM: 'Bottom',
  CENTER: 'Center',
}

export enum ToastType {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  NEUTRAL = 'Neutral',
}

type ToastProps = {
  testID?: string
  hide: boolean
  type: keyof typeof ToastType
  position?: keyof typeof ToastPosition
  message?: string
  onDismiss?: () => void
  timeOut?: TimeOut
}

export const Toast = ({
  type = 'NEGATIVE',
  hide = false,
  message = '',
  position = 'TOP',
  onDismiss,
  timeOut = TimeOut.FIVE_SECONDS,
}: ToastProps) => {
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | any
    if (!hide) {
      timeout = setTimeout(onDismiss, timeOut)
    }
    return () => clearTimeout(timeout)
  }, [hide, onDismiss, timeOut])

  if (hide || message === '') {
    return null
  }
  const getIcon = () => {
    const Icons = {
      POSITIVE: 'ROUND_TICK',
      NEUTRAL: 'INFO',
      NEGATIVE: 'CLEAR',
    }
    return Icons[type] as IconOptions
  }

  // testID={testID} removed this while migration
  const boxStyle = { ...styles[position].containerView, ...styles[type].bgColor }
  return (
    <Box onPress={onDismiss} {...boxStyle}>
      {
        //<Icon id={getIcon()} color="WHITE" size="FONT_SIZE_2_EXTRA_LARGE" />
      }
      <Text {...styles[type].titleText}>{message}</Text>
    </Box>
  )
}
